import { Component, Input, OnInit, inject } from "@angular/core";
import { PlatformType } from "@root/config";
import { InputNumber } from "ng-zorro-antd/core/util";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";

interface IModalData {
  thirdpartyType: PlatformType;
}

@Component({
  selector: "v4-connect-success",
  templateUrl: "./connect-success.component.html",
  styleUrls: ["./connect-success.component.scss"],
})
export class V4ConnectSuccessComponent implements OnInit {
  readonly Platform: typeof PlatformType = PlatformType;
  readonly modalData: IModalData = inject(NZ_MODAL_DATA);
  thirdpartyType = this.modalData.thirdpartyType;
  get docLink() {
    const map = {
      [PlatformType.Airbnb]: "https://hostex.io/help/airbnb-connection/",
      [PlatformType.Booking]: "https://hostex.io/help/booking-com-connection/",
      [PlatformType.Agoda]: "https://hostex.io/help/agoda-connection/",
      [PlatformType.Vrbo]: "https://hostex.io/help/vrbo-connection/",
    };
    return map[this.thirdpartyType];
  }

  showDocLink =
    [PlatformType.Airbnb, PlatformType.Booking, PlatformType.Agoda, PlatformType.Vrbo].indexOf(this.thirdpartyType) !==
    -1;

  constructor(private modalRef: NzModalRef) {}

  ngOnInit() {}

  onClose() {
    this.modalRef.destroy();
  }
}
